<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-form-group label-for="tanggal-ba">
          <template #label>Tanggal BA <span class="text-danger">*</span></template>
          <b-form-input
            id="tanggal-ba"
            :value="value.tanggal_ba"
            type="date"
            @input="updateField('tanggal_ba', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nomor-ba">
          <template #label>Nomor BA <span class="text-danger">*</span></template>
          <b-form-input
            id="nomor-ba"
            :value="value.nomor_ba"
            type="text"
            @input="updateField('nomor_ba', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="provinsi-ba">
          <template #label>Provinsi <span class="text-danger">*</span></template>
          <v-select
            id="provinsi-ba"
            :value="value.provinsi"
            :options="provinsiOptions"
            :reduce="provinsi => provinsi.id"
            label="nama_provinsi"
            placeholder="Pilih Provinsi"
            :disabled="isLoadingProvinsi"
            @input="selectProvinsi"
          />
          <small v-if="isLoadingProvinsi" class="text-muted">Memuat daftar provinsi...</small>
          <small v-else-if="provinsiError" class="text-danger">{{ provinsiError }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kabupaten-ba">
          <template #label>Kabupaten/Kota <span class="text-danger">*</span></template>
          <v-select
            id="kabupaten-ba"
            :value="value.kabupaten"
            :options="kabupatenOptions"
            :reduce="kabupaten => kabupaten.id"
            label="nama_kabupaten"
            placeholder="Pilih Kabupaten/Kota"
            :disabled="!value.provinsi || isLoadingKabupaten"
            @input="selectKabupaten"
          />
          <small v-if="isLoadingKabupaten" class="text-muted">Memuat daftar kabupaten/kota...</small>
          <small v-else-if="kabupatenError" class="text-danger">{{ kabupatenError }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kecamatan-ba">
          <template #label>Kecamatan <span class="text-danger">*</span></template>
          <v-select
            id="kecamatan-ba"
            :value="value.kecamatan"
            :options="kecamatanOptions"
            :reduce="kecamatan => kecamatan.id"
            label="nama_kecamatan"
            placeholder="Pilih Kecamatan"
            :disabled="!value.provinsi || !value.kabupaten || isLoadingKecamatan"
            @input="selectKecamatan"
          />
          <small v-if="isLoadingKecamatan" class="text-muted">Memuat daftar kecamatan...</small>
          <small v-else-if="kecamatanError" class="text-danger">{{ kecamatanError }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kelurahan-ba">
          <template #label>Kelurahan <span class="text-danger">*</span></template>
          <b-form-input
            id="kelurahan-ba"
            :value="value.kelurahan"
            type="text"
            @input="updateField('kelurahan', $event)"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group label-for="isi-berita-acara" class="mb-4">
      <template #label>Isi Berita Acara <span class="text-danger">*</span></template>
      <ckeditor
        id="isi-berita-acara"
        :editor="wygEditor"
        :value="value.isi_berita_acara || ''"
        @input="updateField('isi_berita_acara', $event)"
      />
    </b-form-group>

    <section class="mb-4">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h5 class="mb-0">Penandatangan <span class="text-danger">*</span></h5>
        <b-button size="sm" variant="primary" @click="tambahPenandatangan">
          <i class="fa fa-plus"></i> Tambah Penandatangan
        </b-button>
      </div>

      <b-card
        v-for="(penandatangan, index) in value.penandatangan"
        :key="penandatangan.id"
        class="mb-3"
      >
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h6 class="mb-0">Penandatangan {{ index + 1 }}</h6>
          <b-button
            v-if="value.penandatangan.length > 1"
            size="sm"
            variant="danger"
            @click="hapusPenandatangan(penandatangan.id)"
          >
            <i class="fa fa-trash"></i> Hapus
          </b-button>
        </div>
        <b-row>
          <b-col md="6">
            <b-form-group :label-for="`penandatangan-kategori-${penandatangan.id}`">
              <template #label>Kategori <span class="text-danger">*</span></template>
              <b-form-select
                :id="`penandatangan-kategori-${penandatangan.id}`"
                :value="penandatangan.kategori"
                :options="kategoriPenandatanganOptions"
                class="form-control"
                @change="updatePenandatangan(penandatangan.id, 'kategori', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label-for="`penandatangan-nama-${penandatangan.id}`">
              <template #label>Nama <span class="text-danger">*</span></template>
              <b-form-input
                :id="`penandatangan-nama-${penandatangan.id}`"
                :value="penandatangan.nama"
                type="text"
                @input="updatePenandatangan(penandatangan.id, 'nama', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label-for="`penandatangan-jabatan-${penandatangan.id}`">
              <template #label>Jabatan <span class="text-danger">*</span></template>
              <b-form-input
                :id="`penandatangan-jabatan-${penandatangan.id}`"
                :value="penandatangan.jabatan"
                type="text"
                @input="updatePenandatangan(penandatangan.id, 'jabatan', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label-for="`penandatangan-instansi-${penandatangan.id}`">
              <template #label>Instansi/Unit Kerja <span class="text-danger">*</span></template>
              <b-form-input
                :id="`penandatangan-instansi-${penandatangan.id}`"
                :value="penandatangan.instansi_unit_kerja"
                type="text"
                @input="updatePenandatangan(penandatangan.id, 'instansi_unit_kerja', $event)"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </section>

    <input-image-multiple
      :value="value.dokumentasi"
      label="Dokumentasi"
      empty-text="Belum ada gambar dokumentasi."
      @input="updateField('dokumentasi', $event)"
    />

    <input-image-multiple
      :value="value.lampiran_peta_penilaian"
      label="Lampiran Peta Penilaian"
      empty-text="Belum ada lampiran peta penilaian."
      @input="updateField('lampiran_peta_penilaian', $event)"
    />

    <div class="d-flex justify-content-between">
      <b-button variant="secondary" @click="$emit('kembali')">Kembali</b-button>
      <div class="d-flex flex-wrap justify-content-end">
        <b-button
          type="button"
          variant="outline-primary"
          class="mr-2 mb-2"
          @click="showPreviewModal = true"
        >
          <i class="fa fa-eye"></i> Preview Berita Acara
        </b-button>
        <b-button variant="success" class="mr-2 mb-2" @click="$emit('simpan')">Simpan</b-button>
        <b-button variant="primary" class="mb-2" @click="$emit('selanjutnya')">Selanjutnya</b-button>
      </div>
    </div>

    <document-preview-modal v-model="showPreviewModal" title="Preview Berita Acara" />
  </div>
</template>

<script>
import axios from 'axios'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import vSelect from 'vue-select'
import InputImageMultiple from '@/components/InputImageMultiple/InputImageMultiple.vue'
import DocumentPreviewModal from '@/components/DocumentPreviewModal/DocumentPreviewModal.vue'

export default {
  name: 'FormBeritaAcaraPusat',
  components: { vSelect, InputImageMultiple, DocumentPreviewModal },
  props: {
    value: {
      type: Object,
      default: () => ({
        tanggal_ba: '',
        nomor_ba: '',
        provinsi: '',
        kabupaten: '',
        kecamatan: '',
        kelurahan: '',
        isi_berita_acara: '',
        penandatangan: [{
          id: 1,
          kategori: '',
          nama: '',
          jabatan: '',
          instansi_unit_kerja: '',
        }],
        dokumentasi: [],
        lampiran_peta_penilaian: [],
      }),
    },
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}'),
      wygEditor: ClassicEditor,
      provinsiOptions: [],
      kabupatenOptions: [],
      kecamatanOptions: [],
      isLoadingProvinsi: false,
      isLoadingKabupaten: false,
      isLoadingKecamatan: false,
      provinsiError: '',
      kabupatenError: '',
      kecamatanError: '',
      kabupatenRequestId: 0,
      kecamatanRequestId: 0,
      nextPenandatanganId: 1,
      showPreviewModal: false,
      kategoriPenandatanganOptions: [
        { value: '', text: 'Pilih Kategori' },
        { value: 'Penilai', text: 'Penilai' },
        { value: 'Penanggung Jawab Pemrakarsa', text: 'Penanggung Jawab Pemrakarsa' },
      ],
    }
  },
  mounted() {
    this.nextPenandatanganId = (this.value.penandatangan || []).reduce(
      (maxId, penandatangan) => Math.max(maxId, Number(penandatangan.id) || 0),
      0,
    ) + 1
    this.getProvinsi()
  },
  methods: {
    getApiOption() {
      return { headers: { Authorization: `Bearer ${this.user.accessToken}` } }
    },
    updateField(field, fieldValue) {
      this.$emit('input', { ...this.value, [field]: fieldValue })
    },
    tambahPenandatangan() {
      const penandatangan = {
        id: this.nextPenandatanganId++,
        kategori: '',
        nama: '',
        jabatan: '',
        instansi_unit_kerja: '',
      }
      this.$emit('input', {
        ...this.value,
        penandatangan: [...(this.value.penandatangan || []), penandatangan],
      })
    },
    updatePenandatangan(id, field, fieldValue) {
      const penandatangan = (this.value.penandatangan || []).map((item) => (
        item.id === id ? { ...item, [field]: fieldValue } : item
      ))
      this.$emit('input', { ...this.value, penandatangan })
    },
    hapusPenandatangan(id) {
      const current = this.value.penandatangan || []
      if (current.length <= 1) return
      this.$emit('input', {
        ...this.value,
        penandatangan: current.filter(item => item.id !== id),
      })
    },
    async selectProvinsi(idProvinsi) {
      const selectedProvinsi = idProvinsi || ''
      this.$emit('input', {
        ...this.value,
        provinsi: selectedProvinsi,
        kabupaten: '',
        kecamatan: '',
      })
      this.kabupatenOptions = []
      this.kecamatanOptions = []
      this.kabupatenError = ''
      this.kecamatanError = ''
      this.kabupatenRequestId++
      this.kecamatanRequestId++
      this.isLoadingKabupaten = false
      this.isLoadingKecamatan = false
      if (selectedProvinsi) await this.getKabupaten(selectedProvinsi)
    },
    async selectKabupaten(idKabupaten) {
      const selectedKabupaten = idKabupaten || ''
      this.$emit('input', {
        ...this.value,
        kabupaten: selectedKabupaten,
        kecamatan: '',
      })
      this.kecamatanOptions = []
      this.kecamatanError = ''
      this.kecamatanRequestId++
      this.isLoadingKecamatan = false
      if (selectedKabupaten && this.value.provinsi) await this.getKecamatan(selectedKabupaten)
    },
    selectKecamatan(idKecamatan) {
      this.updateField('kecamatan', idKecamatan || '')
    },
    async getProvinsi() {
      this.isLoadingProvinsi = true
      this.provinsiError = ''
      try {
        const response = await axios.get(
          `${this.baseapiPengendalian}api/provinsi?sort=id,ASC&limit=0`,
          this.getApiOption(),
        )
        this.provinsiOptions = response.data.data || []
        if (this.value.provinsi) await this.getKabupaten(this.value.provinsi)
      } catch (error) {
        this.provinsiError = 'Daftar provinsi gagal dimuat.'
      } finally {
        this.isLoadingProvinsi = false
      }
    },
    async getKabupaten(idProvinsi) {
      const requestId = ++this.kabupatenRequestId
      this.isLoadingKabupaten = true
      this.kabupatenError = ''
      try {
        const response = await axios.get(
          `${this.baseapiPengendalian}api/kabupaten?sort=id,ASC&filter=id_provinsi,=,${idProvinsi}&limit=0`,
          this.getApiOption(),
        )
        if (requestId !== this.kabupatenRequestId || String(this.value.provinsi) !== String(idProvinsi)) return
        this.kabupatenOptions = response.data.data || []
        if (this.value.kabupaten) await this.getKecamatan(this.value.kabupaten)
      } catch (error) {
        if (requestId === this.kabupatenRequestId) this.kabupatenError = 'Daftar kabupaten/kota gagal dimuat.'
      } finally {
        if (requestId === this.kabupatenRequestId) this.isLoadingKabupaten = false
      }
    },
    async getKecamatan(idKabupaten) {
      const requestId = ++this.kecamatanRequestId
      this.isLoadingKecamatan = true
      this.kecamatanError = ''
      try {
        const response = await axios.get(
          `${this.baseapiPengendalian}api/kecamatan?sort=id,ASC&filter=id_kabupaten,=,${idKabupaten}&limit=0`,
          this.getApiOption(),
        )
        if (requestId !== this.kecamatanRequestId || String(this.value.kabupaten) !== String(idKabupaten)) return
        this.kecamatanOptions = response.data.data || []
      } catch (error) {
        if (requestId === this.kecamatanRequestId) this.kecamatanError = 'Daftar kecamatan gagal dimuat.'
      } finally {
        if (requestId === this.kecamatanRequestId) this.isLoadingKecamatan = false
      }
    },
  },
}
</script>
